import { FC } from "react";
import LoadingScreen from "../app/loadingscreen/LoadingScreen.component";

const LoadingScreenPage: FC = () => <LoadingScreen />;

export default LoadingScreenPage;